var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartAverage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10937_27995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2496 18C14.5503 18 13.4776 14.8681 12.4402 11.8396C11.4569 8.96873 10.4396 6 8.24961 6C7.73819 6.03007 7.24729 6.21172 6.83948 6.5218C6.43167 6.83188 6.1254 7.25635 5.95971 7.74112L4.53809 7.26285C4.57581 7.15005 5.49096 4.5 8.24961 4.5C11.5114 4.5 12.7588 8.14103 13.8596 11.3534C14.766 14 15.6221 16.5 17.2496 16.5C17.761 16.4699 18.2519 16.2883 18.6597 15.9782C19.0676 15.6681 19.3738 15.2436 19.5395 14.7589L20.9611 15.2372C20.9234 15.3499 20.0083 18 17.2496 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21V12.75H4.5V11.25H3V1.5H1.5V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H22.5V21H3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.25H6V12.75H7.5V11.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.25H9V12.75H10.5V11.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.25H15V12.75H16.5V11.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 11.25H18V12.75H19.5V11.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.25H21V12.75H22.5V11.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10937_27995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartAverage);
export default __webpack_public_path__ + "static/media/chart-average.8cc8934e4e8fe3aa29f800de1ea13ef7.svg";
export { ForwardRef as ReactComponent };